import React from 'react';
import PropTypes from 'prop-types';
import { ProductListItem } from 'components/ContentfulFields/ProductCard';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import get from 'lodash/get';
import { F } from 'components/Ui';
import { formatCurrency } from 'utils/common';

import { Default, Mobile } from 'components/Media';
import styles from './styles.scss';

const DeliveryItem = ({ delivery, onAction, isTableLayout }) => {
  const orderItems = get(delivery, 'transactionDetails', []);

  return (
    <div className={styles.orderContainer}>
      <div className={styles.deliveryItems}>
        {!isTableLayout &&
          orderItems.map((item) => (
            <ProductListItem
              key={`${item.itemNumber}${item.amount}${item.quantity}`}
              product={item}
              onAction={onAction}
            />
          ))}
        {isTableLayout && (
          <TableContainer>
            <Table className={styles.tableDelivery} size="small">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <F>Details:</F>
                  </TableCell>
                  <Mobile>
                    <TableCell>
                      <F>QTY</F>
                    </TableCell>
                  </Mobile>
                  <Default>
                    <TableCell>
                      <F>Quantity:</F>
                    </TableCell>
                  </Default>
                  <TableCell>
                    <F>Each:</F>
                  </TableCell>
                  <TableCell>
                    <F>Total:</F>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orderItems.map((item) => (
                  <TableRow
                    key={`${item.itemNumber}${item.amount}${item.quantity}`}
                  >
                    <TableCell>
                      {item.longDescription || item.description}
                    </TableCell>
                    <TableCell>{get(item, 'quantity', 1)}</TableCell>
                    <TableCell>
                      {formatCurrency(get(item, 'price', 0))}
                    </TableCell>
                    <TableCell>
                      {formatCurrency(get(item, 'amount', 0))}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <hr />
        <TableContainer>
          <Table className={styles.tableTotals} size="small">
            <TableBody>
              <TableRow>
                <TableCell>
                  <F>Subtotal</F>
                </TableCell>
                <TableCell>
                  {formatCurrency(get(delivery, 'subTotal', 0))}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <F>Sales Tax</F>
                </TableCell>
                <TableCell>
                  {formatCurrency(get(delivery, 'taxTotals[0].taxAmount', 0))}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <F>Total</F>
                </TableCell>
                <TableCell>
                  {formatCurrency(get(delivery, 'total', 0))}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

DeliveryItem.propTypes = {
  delivery: PropTypes.object.isRequired,
  onAction: PropTypes.func,
  isTableLayout: PropTypes.bool,
};

export default DeliveryItem;
